import { render, staticRenderFns } from "./payout-details.vue?vue&type=template&id=ecd2deee&"
import script from "./payout-details.vue?vue&type=script&lang=js&"
export * from "./payout-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports